module.exports = __webpack_public_path__ + "img/68.9192d2af.jpg";